module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-dialog', {
    staticClass: "category-dialog",
    attrs: {
      "title": _vm.category.id ? _vm.$t('actions.category.edit') : _vm.$t('actions.category.new'),
      "size": "small",
      "visible": _vm.dialogVisible
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      }
    }
  }, [_c('image-uploader', {
    staticClass: "cover-wrapper",
    attrs: {
      "title": _vm.$t('actions.category.cover')
    },
    on: {
      "click": _vm.openMediaImageDialog
    },
    model: {
      value: (_vm.category.cover),
      callback: function($$v) {
        _vm.category.cover = $$v
      },
      expression: "category.cover"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "inputs"
  }, [_c('el-input', {
    attrs: {
      "placeholder": _vm.$t('placeholder.category.name')
    },
    model: {
      value: (_vm.category.name),
      callback: function($$v) {
        _vm.category.name = $$v
      },
      expression: "category.name"
    }
  }), _vm._v(" "), _c('el-input', {
    attrs: {
      "type": "textarea",
      "rows": 4,
      "resize": "false",
      "placeholder": _vm.$t('placeholder.category.description')
    },
    model: {
      value: (_vm.category.description),
      callback: function($$v) {
        _vm.category.description = $$v
      },
      expression: "category.description"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "publicity"
  }, [_c('el-checkbox', {
    staticClass: "publicity",
    model: {
      value: (_vm.category.publicity),
      callback: function($$v) {
        _vm.category.publicity = $$v
      },
      expression: "category.publicity"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t('actions.category.publicity')) + "\n          "), _c('a', {
    attrs: {
      "target": "_blank",
      "href": "http://mp.weixin.qq.com/s/jXd74hGwEVlXEiGtPHW8cQ"
    }
  }, [_c('i', {
    staticClass: "ppj-icon-help-circled"
  })])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "buttons",
    slot: "footer"
  }, [_c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.category.id),
      expression: "category.id"
    }],
    staticClass: "left",
    attrs: {
      "type": "danger",
      "plain": true
    },
    on: {
      "click": _vm.removeGroup
    }
  }, [_vm._v(_vm._s(_vm.$t('actions.category.remove')))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "text"
    },
    on: {
      "click": function($event) {
        _vm.close()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('common.buttons.cancel')))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.update()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('common.buttons.ok')))])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4f849b62"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/plugins/category/edit.dialog.vue
// module id = 918
// module chunks = 3